import React from 'react'

const HelpCenterPage = () => {
  return (
    <main className="min-h-screen bg-slate-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <header className="mb-10 sm:mb-14">
          <p className="text-sm font-semibold text-emerald-600 mb-2 uppercase tracking-wide">
            Help Center
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-slate-900 mb-4 leading-tight">
            Help and support for using Obule
          </h1>
          <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-3xl font-light">
            This Help Center provides high‑level guidance on using Obule as an attendee or
            organizer. For detailed, account‑specific issues, please contact support or check your
            in‑app help links.
          </p>
        </header>

        <div className="space-y-8 text-base text-slate-600 leading-relaxed font-light">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Attendees</h2>
            <p>
              As an attendee, you can browse events and offers, purchase tickets securely, view and
              manage your orders, and access your tickets from your dashboard. If you&apos;re new
              to Obule, start by creating an account, exploring events that match your interests,
              and reviewing the event details before you buy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Organizers</h2>
            <p>
              Centers and organizers can use Obule to create events, configure offers, track sales,
              and manage attendees. The center dashboard provides analytics and wallet tools to help
              you understand performance and manage payouts. For onboarding support, reach out to
              our organizer success team.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Common questions</h2>
            <p>
              For quick answers to common questions about payments, tickets, account updates, and
              troubleshooting, you can also visit our FAQ page from the footer or search in your
              dashboard&apos;s support section.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}

export default HelpCenterPage

